module.exports = __webpack_public_path__ + "static/media/menu--light.afb6b257.svg";